import { ssGet, ssRemove, ssSet } from "./auth";
import {
  isLicenseBlockedDetail,
  type LicenseBlockedDetail,
} from "./licenseNotice";

// Отказът „лицензът е спрян" трябва да стигне до модала „Достъпът е спрян"
// (`LicenseNoticeHost`), а изходът (`endSessionForExpiredLicense` в
// sessionRecovery.ts) е ПЪЛНА навигация към /login — Redux не я преживява.
// Затова два канала:
//  • sessionStorage — пред навигацията; новият документ го взима веднъж при
//    монтирането на Host-а (същият таб, не и съседните);
//  • в паметта — когато навигация няма (вече сме на /login).

const PENDING_KEY = "license_blocked";

type BlockedLicenseListener = (detail: LicenseBlockedDetail) => void;
const listeners = new Set<BlockedLicenseListener>();

/** Оставя отказа за документа след навигацията към /login. */
export function rememberBlockedLicense(detail: LicenseBlockedDetail) {
  ssSet(PENDING_KEY, JSON.stringify(detail));
}

/** Взима (и трие) оставения отказ; повреден запис = нищо. */
export function takeBlockedLicense(): LicenseBlockedDetail | null {
  const raw = ssGet(PENDING_KEY);
  if (raw === null) return null;
  ssRemove(PENDING_KEY);
  try {
    const parsed: unknown = JSON.parse(raw);
    return isLicenseBlockedDetail(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/** Показва отказа веднага в ТОЗИ документ (без навигация). */
export function announceBlockedLicense(detail: LicenseBlockedDetail) {
  listeners.forEach((listener) => listener(detail));
}

export function onBlockedLicense(listener: BlockedLicenseListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
